import { inject, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

@Injectable({ providedIn: 'root' })
export class ToastManager {
  private readonly toastCtrl = inject(ToastController);

  private readonly defaultConfig = {
    duration: 4000,
    position: 'top' as const,
    cssClass: 'custom-toast'
  };

  private readonly colorMap: Record<ToastType, string> = {
    success: 'success',
    error: 'danger',
    warning: 'warning',
    info: 'primary'
  };

  async show(message: string, type: ToastType = 'info', duration?: number) {
    const toast = await this.toastCtrl.create({
      ...this.defaultConfig,
      message,
      color: this.colorMap[type],
      duration: duration ?? this.defaultConfig.duration
    });

    await toast.present();
    return toast;
  }

  async success(message: string, duration?: number) {
    return this.show(message, 'success', duration);
  }

  async error(message: string, duration?: number) {
    return this.show(message, 'error', duration);
  }

  async warning(message: string, duration?: number) {
    return this.show(message, 'warning', duration);
  }

  async info(message: string, duration?: number) {
    return this.show(message, 'info', duration);
  }
}
